import React from "react";

const Tracking= props => {

  return(
    <div className="Home">

      <h1>Tracking</h1>
    </div>
  );
}

export default Tracking;